import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';
import PastBillsNav from './PastBillsNav'
import firebase from 'firebase/app';

export default class PastBillsView extends Component {
    constructor(props){
      super(props);
      this.state = {
        checked: null,
        selectedOption: "",
        billsValue: null,
        billsRef: null,
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      }
    }
  
    handleChange = (event) => {
      this.setState ({
        selectedOption: event.target.name
      })
      let route = "/pastbills/" + event.target.name;
      this.props.history.push(route);
    }

    componentDidMount() {
      console.log(this.props)
      let data = [];
      if (this.props.signedIn){
        let userKey = this.props.user.email.replace(/[^a-zA-Z0-9]/g, "");
        let billsRef = firebase.database().ref('userBills/' + userKey + "/gas");
        this.setState( {billsRef: billsRef })
        billsRef.on('value', (snapshot) => {
          snapshot.forEach((childSnapshot, index) => {
            let split = childSnapshot.val().month.split('-');
            let month = this.state.months[split[0] - 1] + " " + split[1];
            const item = (<li> 
              <div className="card past-bills-card"> 
                <h2>{month}</h2> 
                <p>Amount: ${childSnapshot.val().amount}</p> 
                <p>Usage: {childSnapshot.val().usage} thm</p> 
              </div> 
              </li>)
            data.push(item);
            this.setState({billData: data})
          })
        });
      }
      if (data.length === 0) {
        let item = (<p className="m-5">You have no Gas data</p>)
        this.setState({billData:item})
      }
      
    }
  
  componentWillUnmount(){
    if (this.props.signedIn){
    this.state.billsRef.off();
    }
  }
  
    render(){
         

      return (
        <body id="main-content" className="container">
          <NavLink to="/home" className="previous round back-button" aria-label="Back to dashboard">&#8249;</NavLink>
          <h2 className="upload-center">Past Bills</h2>
          
          <PastBillsNav/>

          <div className='past-bills-container'>
            <ul className="past-bills-list">
              {this.state.billData}
            </ul>

          </div>
          
        </body>
      )
    }
  }